import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { RootState } from '@/store';
import { API_ENDPOINTS, API_SLICE, BASE_URL } from '@/utils/constants/apiEndpoints';

import {
  GetScheduledTransmissionsResponse,
  GetScheduleTermDaysResponse
} from '@/types/deviceSchedule';

export const scheduledTransmissionApiSlice = createApi({
  reducerPath: 'scheduledTransmissionApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token;
      if (token) {
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  tagTypes: Object.values(API_SLICE),
  endpoints: (builder) => ({
    getScheduledTransmissions: builder.query<GetScheduledTransmissionsResponse, string>({
      query: (deviceId) => ({
        url: API_ENDPOINTS.SCHEDULE_TRANSMISSION.LIST,
        method: 'GET',
        params: { deviceId }
      }),
      providesTags: (_result, _error, deviceId) => [
        { type: API_SLICE.ScheduledTransmission, id: deviceId }
      ]
    }),

    getScheduleTermDays: builder.query<GetScheduleTermDaysResponse, void>({
      query: () => ({
        url: `${API_ENDPOINTS.SCHEDULE_TRANSMISSION.LIST}/schedule-terms`,
        method: 'GET'
      })
    }),
    resetScheduledTransmissions: builder.mutation<void, string>({
      query: (deviceId) => ({
        url: API_ENDPOINTS.SCHEDULE_TRANSMISSION.RESET,
        method: 'PATCH',
        params: { deviceId }
      })
    })
  })
});

export const {
  useGetScheduledTransmissionsQuery,
  useGetScheduleTermDaysQuery,
  useResetScheduledTransmissionsMutation
} = scheduledTransmissionApiSlice;
